import { Autocomplete, SelectSize, IconClose } from '@ui/src';
import InfoRow from '../../common/info-row';
import useRequiredCurrencies from '../hooks/use-required-currencies';
import { CountriesOfInterestTypes } from './types';

import cn from '../styles.module.css';
import commonStyles from '../../common/styles.module.css';

const RequiredCurrencies = ({
  value,
  setValue,
  setValuesList,
  index,
  values,
  list,
  disabled,
  title,
  error,
  clearErrors,
}: CountriesOfInterestTypes) => {
  const { onChange, deleteCurrency, errorVisible } = useRequiredCurrencies({
    values,
    index,
    setValue,
    setValuesList,
  });

  return (
    <InfoRow
      title={title}
      id="requiredCurrenciesCryptoId"
      borderless
      lessPadding
    >
      <>
        <div className={cn.sicCodeRow}>
          <Autocomplete
            name={`requiredCurrenciesCryptoId-${index}`}
            placeholder="Select currency"
            value={value.id}
            onChange={(e) => {
              onChange(e);
              clearErrors('requiredCurrenciesCryptoId');
            }}
            className={`${commonStyles.newApplicationAutocomplete} ${
              disabled ? commonStyles.newApplicationAutocompleteDisabled : ''
            }`}
            size={SelectSize.SMALL}
            list={list}
            disabled={disabled}
            tabIndex={disabled ? -1 : 0}
            error={error}
            borderless
          />
          {!disabled && (
            <button
              type="button"
              className={cn.deleteSicCodeButton}
              onClick={() => deleteCurrency(value.id)}
              aria-label="Delete button"
              tabIndex={-1}
            >
              <IconClose width={15} height={15} />
            </button>
          )}
        </div>
        {errorVisible && (
          <div className={cn.sicCodesError}>Currencies must be unique</div>
        )}
      </>
    </InfoRow>
  );
};

export default RequiredCurrencies;
